<template>
    <div class="category bold">
        <div class="category-item" :class="{'active' : categoryId === item.id}" v-for="(item, index) in categorys" :key="index" @click="onChangeCategory(item)">
            {{item.title}}
        </div>
    </div>
</template>
<script>
import {getClassification} from '@/api/server/classification'
export default {
    name: "CategoryComponent",
    props: {
     category:{
       types: Number,
       required: true
     }
   },
    data () {
        return {
            categoryId: this.category,
            categorys: []
        }
    },
    methods: {
        onChangeCategory (item) {
          if (item) {
            this.categoryId = item.id
            this.$emit('changeCategory', item)
          }
        },
        _getClassification () {
            getClassification().then( (res) => {
                if (res.code === 200 && res.data) {
                    this.categorys = res.data
                }
            })
        },
        _reset () {
            this._getClassification()
        }
    },
    mounted () {
        this._reset()
    }
}
</script>
<style lang="scss" scoped>
.bold {
    font-weight: bold;
}
.category {
    border-top: solid 1px #ddd;
    display: flex;
    font-size: 14px;
    line-height: 32px;
    .category-item {
        margin-right: 10px;
        color: #9d9ea2;
    }
    .active {
        color: #e23435;
    }
}
</style>